import ForceChangePassword from "@/features/Users/ForceChangePassword";
import { useSidePanel } from "@/modules/side-panel";

export const useForceChangePassword = (user) => {
  const { openSidePanel } = useSidePanel();

  const onForceChangePassword = () => {
    openSidePanel({
      title: user.name,
      component: <ForceChangePassword user={user} />,
    });
  };

  return {
    onForceChangePassword,
  };
};
